// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import Search from "../_modules/common/search/search";
import Sidebar from "../_modules/common/sidebar/sidebar";
import WasThisHelpful
  from "../_modules/common/was-this-helpful/was-this-helpful";
import Accordion from "../_modules/common/accordion/accordion";
import Alert from "../_modules/common/alert/alert";
import Footer from "../_modules/common/footer/footer";

import TablePreview from "../_modules/table-preview/table-preview";

import Homepage from "../_modules/homepage/homepage";
import Landing from "../_modules/landing/landing";
import Product from "../_modules/product/product";
import Standard from "../_modules/standard/standard";
import RicFeedbackForm from '../_modules/common/ric-feedback-form/ric-feedback-form';
import Form from '../_modules/form/form';
import Carousel from '../_modules/carousel/carousel';

window.$ = jQuery;

$(() => {
  new Search();
  new Sidebar();
  new WasThisHelpful();
  new Accordion();
  new Alert();
  new Footer();

  new Homepage();
  new Landing();
  new Product();
  new Standard();

  new TablePreview();
  new Form();
  new Carousel();
  
  $('.-js-print-page').on('click', function (e) {
    e.preventDefault();

    window.print();
  });
});

function getWindowWidth() {
  var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  return w;
}

window.recaptchaCallback = () => {
  jQuery('form.ric-feedback-form--form .ric-feedback-form--form__captcha .g-recaptcha-response').change();
}

(function ($) {

  /**
   * Load recaptcha.
   */
  Drupal.behaviors.loadRecaptcha = {
    attach: function attach(context, settings) {
      function loadRecaptcha() {
        var recaptchaScript = $('script[src*="recaptcha/api.js"]', context);
        
        if (recaptchaScript.length) {
          // The script with "recaptcha/api.js" in the src attribute is already present
          // Execute the timestamp function
          timestamp();
        } else {
          // The script with "recaptcha/api.js" in the src attribute is not present
          // Create a new script element and add it to the document
          var newScript = $('<script></script>');
          newScript.attr('src', 'https://www.google.com/recaptcha/api.js');
          $('body', context).append(newScript);
          setTimeout(timestamp, 0); // Execute the timestamp function in the next thread loop
        }
      }
      
      function timestamp() {
        var response = $('#g-recaptcha-response', context);
        if (!response.length || response.val().trim() === "") {
          var elems = JSON.parse($('[name="captcha_settings"]').val());
          elems["ts"] = JSON.stringify(new Date().getTime());
          $('[name="captcha_settings"]').val(JSON.stringify(elems));
        }
      }
      
      // Call loadRecaptcha to check if the reCAPTCHA script is already loaded or load it dynamically
      loadRecaptcha();
    }
  };

  /**
   * Search icon.
   */
  Drupal.behaviors.ricSearch = {
    attach: function (context, settings) {
      var $mobileIcon = $('.mobile-expand-search', context);
      var $searchForm = $('.region-search-mobile', context);

      $mobileIcon.click(function (e) {
        e.preventDefault();

        $(this).toggleClass('search-open');
        $(this).attr('aria-expanded', $(this).hasClass('search-open') ? 'true' : 'false');
        $searchForm.toggleClass('search-open');
      });

    }
  };

  /**
   * Text resize.
   */
  Drupal.behaviors.ricTextResize = {
    attach: function (context, settings) {
      var $widget = $('.text-resize', context);
      var $body = $('body', context);
      var textLarge = 'text-large';

      $widget.find('.font-large').click(function (e) {
        e.preventDefault();
        $body.addClass(textLarge);
      });

      $widget.find('.font-small').click(function (e) {
        e.preventDefault();
        $body.removeClass(textLarge);
      });

      $widget.find('.reset').click(function (e) {
        e.preventDefault();
        $body.removeClass(textLarge);
      });
    }
  };

  /**
   * Desktop and mobile menu.
   */
  Drupal.behaviors.ricMenu = {
    attach: function (context, settings) {
      var $regionMobileNavigation = $('.region-navigation-mobile', context);
      var $widgetDesktop = $('#block-ric-mainnavigation', context);
      var $widgetMobile = $('#block-mainnavigation-2', context);
      var $widgetMobileButton = $('.mobile-expand-menu', context);

      $widgetDesktop.find('ul').superfish();

      $widgetMobileButton.click(function (e) {
        e.preventDefault();

        $(this).toggleClass('menu-open');
        $regionMobileNavigation.toggleClass('menu-open');
      });

      // Mobile accordion.
      if ($widgetMobile.length > 0) {
        var $expandableLinks = $widgetMobile.children('.menu').children('.menu-item--expanded');
        $expandableLinks.each(function(i, item) {
          // Initial setup.
          var $item = $(item);
          $item.addClass('ric-mobile-menu--closed');
          var buttonTitle = 'Toggle submenu for ' + $item.children('a').text();
          var controlId = 'ric-mobile-menu-submenu-' + i
          $item.children('a').wrap('<div class="ric-mobile-menu__title" />');
          var $btn = $('<button class="ric-mobile-menu__toggle" aria-expanded="false" aria-controls="' + controlId + '" aria-label="' + buttonTitle + '"><span>' + buttonTitle + '</span></button>');
          $item.children('.ric-mobile-menu__title').append($btn);
          $item.children('ul').attr('id', controlId);
          $btn.on('click', function() {
            var toOpen = !$item.hasClass('ric-mobile-menu--opened');
            $btn.attr('aria-expanded', toOpen);
            $item.toggleClass('ric-mobile-menu--closed', !toOpen).toggleClass('ric-mobile-menu--opened', toOpen);
          })
        })
      }
    }
  };

  /**
   * Feature tiles.
   */
  Drupal.behaviors.ricFeatureTiles = {
    attach: function (context, settings) {
      var $featureTiles = $('.paragraph--type--product-feature-tiles', context);
      var setMargin = function () {
        if (getWindowWidth() >= 768 && getWindowWidth() < 980) {
          // Reset style.
          $featureTiles.find('.ric-product-feature-tile__title h2').removeAttr('style');

          var calculateMaxHeightPerRow = function ($currentEl, row) {
            // The markup has 4 tiles per row, on tablet it become 2 tiles.
            var titleMaxHeight = 0;
            var $items = $currentEl.find('> .field__item:nth-child(-n+2)');

            if (row === 'second') {
              $items = $currentEl.find('> .field__item:nth-child(n+3)');
            }

            $items.each(function () {
              $(this).find('.ric-product-feature-tile__title').each(function () {
                // Get title max height.
                var titleHeight = $(this).outerHeight();

                if (titleHeight >= titleMaxHeight) {
                  titleMaxHeight = titleHeight;
                }
              });
            });

            $items.find('.ric-product-feature-tile__title h2').css({'height': titleMaxHeight});
          };

          // Tablet breakpoint.
          $featureTiles.each(function () {
            calculateMaxHeightPerRow($(this).find('.field--name-field-tiles'), 'first');
            if ($(this).find('.ric-product-feature-tile__title').length > 2) {
              calculateMaxHeightPerRow($(this).find('.field--name-field-tiles'), 'second');
            }
          });
        }
        else if (getWindowWidth() >= 980) {
          // Reset style.
          $featureTiles.find('.ric-product-feature-tile__title h2').removeAttr('style');

          $featureTiles.each(function () {
            var titleMaxHeight = 0;

            $(this).find('.ric-product-feature-tile__title').each(function () {
              // Get title max height.
              var titleHeight = $(this).outerHeight();

              if (titleHeight >= titleMaxHeight) {
                titleMaxHeight = titleHeight;
              }
            });

            $(this).find('.ric-product-feature-tile__title h2').css({'height': titleMaxHeight});
          });
        }
        else {
          // Mobile.
          $featureTiles.find('.ric-product-feature-tile__title h2').removeAttr('style');
        }
      };

      setMargin();
      $(window).resize(function () {
        setMargin();
      });
    }
  }

  /**
   * RIC salesforce feedback form.
   */
  Drupal.behaviors.ricFeedbackForm = {
    attach: function (context, settings) {
      new RicFeedbackForm(context, settings)
    }
  };


  Drupal.behaviors.stickyMenu = {
    attach: function (context, settings) {
      var sticky_menu = $('.paragraph--type--sticky-menu', context);

      sticky_menu.each(function() {
        var anchors = [];
        $(this).find('#navbar-example2 li a[href]').each(function() {
          anchors.push($(this).attr('href'));
        });

        $(this).find('#navbar-example2').addClass('sticky-menu sticky-top').insertBefore($(this).closest('.field__item'));

        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

        const options = {
          // root: null, // Defaults to the browser viewport if not specified or if null.
          // rootMargin: '0px', // default to 0px
          threshold: 0.25 // default to 0
        }

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const elem = entry.target;
            let currentNav = document.querySelector(`#navbar-example2 li a[href="#${elem.id}"]`);
            if (entry.isIntersecting) {
              currentNav.classList.add('active');
              currentNav.setAttribute('aria-current', 'true');
            }
            else {
              currentNav.classList.remove('active');
              currentNav.removeAttribute('aria-current');
            }
          });
        }, options);

        // Track all sections that have an `id` applied
        for (const anchor of anchors) {
          if (document.querySelector(anchor)) {
            observer.observe(document.querySelector(anchor));
          }
        }
      });
    }
  };

  Drupal.behaviors.iframes = {
    attach: function (context) {
      // Title element must be present in head section of document - Add a title element to the head inside iframes
      $('iframe', context).each(function() {
        var iframe = this;
        // Check if the iframe is accessible (may fail for cross-domain iframes)
        try {
          var iframeHead = $(iframe).contents().find('head');
          if (iframeHead.length > 0 && iframeHead.find('title').length === 0) {
            var pageTitle = "Default Title";
            iframeHead.append('<title>' + pageTitle + '</title>');
          }
        } catch (e) {
          console.warn('Unable to access iframe content due to same origin restrictions.');
        }
      });
    }
  };
}(jQuery));
